export default "__VITE_ASSET__81c01d40__"